import Skeleton from '@/components/common/LoadingSkeleton/Skeleton';

export default function BottomSkeleton() {
	return (
		<div className="flex flex-col gap-y-[0.9375rem]">
			<Skeleton className="h-11" lines={8} />
		</div>
	);
}
